import { jsx } from 'react/jsx-runtime';
import { getStyles } from './notestack.config.js';
import { ResourcePreview } from '../ResourcePreview/ResourcePreview.js';
import Tilt from 'react-parallax-tilt';
import { styled } from 'styled-components';
import { IconEmptyState } from '@fabric-app/icons/old';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { useDomContentRect } from '@fabric-app/hooks/useDomContentRect';

const useNoteStackScaleProps = (ref) => {
  const [rect] = useDomContentRect(ref);
  const scale = rect ? rect.width / 650 : 0;
  return {
    scale,
    verticalSpread: scale < 0.3 ? 0.4 : 1
  };
};
const NoteStack = ({ resources, className, scale = 1, noTilt, horizontal = false, noTransition, isHoveredView, horizontalSpread = 1, verticalSpread = 1 }) => {
  const items = resources.slice(0, Math.min(3, resources.length));
  return /* @__PURE__ */ jsx(StyledTilt, {
    perspective: 500,
    transitionSpeed: 1e3,
    scale: 1,
    trackOnWindow: !noTilt,
    tiltMaxAngleY: 10,
    tiltMaxAngleX: 10,
    gyroscope: !noTilt,
    tiltEnable: !noTilt,
    children: /* @__PURE__ */ jsx(List, {
      className,
      style: {
        transform: `scale(${scale})`
      },
      previewsCount: items.length,
      isHoveredView,
      "data-force-hover": isHoveredView,
      scale,
      children: items.length > 0 ? items.map((fdoc, index) => {
        return /* @__PURE__ */ jsx(NewResourceWrapper, {
          style: getStyles({
            listSize: items.length,
            transitionState: isHoveredView ? "hovered" : "default",
            index,
            noTransition,
            horizontalSpread,
            verticalSpread,
            addDepth: !noTilt
          }),
          children: /* @__PURE__ */ jsx(ResourcePreview, {
            resource: fdoc,
            variant: "default",
            isSelectable: false,
            appearence: {
              hideMeta: true
            }
          })
        }, fdoc.id);
      }) : /* @__PURE__ */ jsx(EmptyItem, {
        horizontal,
        style: {
          transition: noTransition ? "none" : void 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        children: /* @__PURE__ */ jsx(StyledEmptyState, {})
      })
    })
  });
};
const NewResourceWrapper = styled.li.withConfig({
  displayName: "NoteStack__NewResourceWrapper",
  componentId: "sc-547eaca3-0"
})([
  `height:240px;width:260px;position:absolute;transition:0.2s all;pointer-events:none;& > *{height:240px;width:260px;}`
]);
const StyledTilt = styled(Tilt).withConfig({
  displayName: "NoteStack__StyledTilt",
  componentId: "sc-547eaca3-1"
})([
  `transform-style:preserve-3d;display:flex;align-items:center;justify-content:center;width:100%;`
]);
const List = styled.ul.withConfig({
  displayName: "NoteStack__List",
  componentId: "sc-547eaca3-2"
})([
  `transform-style:preserve-3d;position:relative;display:flex;align-items:center;justify-content:center;width:100%;height:100%;& [data-preview-content-wrapper]{border-width:`,
  `px;}& [data-preview-content-wrapper='stored_file_thumbnail']{border:`,
  `px solid rgba(`,
  `,0.05);}& [data-preview-content-wrapper='stored_file_icon']{background-color:`,
  `;border:`,
  `px solid rgba(`,
  `,0.05);}& [data-preview-content-wrapper='folder']{box-shadow:none !important;background:`,
  `;}`
], (p) => 1 / p.scale * 2.3, (p) => 1 / p.scale * 2.3, cssVar["color-bg-primary-reverse-rgb"], cssVar["color-bg-primary"], (p) => 1 / p.scale * 2.3, cssVar["color-bg-primary-reverse-rgb"], cssVar["color-bg-secondary"]);
const EmptyItem = styled.li.withConfig({
  displayName: "NoteStack__EmptyItem",
  componentId: "sc-547eaca3-3"
})([
  `position:absolute;width:260px;height:320px;transition:0.3s all;`
]);
const StyledEmptyState = styled(IconEmptyState).withConfig({
  displayName: "NoteStack__StyledEmptyState",
  componentId: "sc-547eaca3-4"
})([
  `width:72px;height:80px;`
]);

export { NoteStack as default, useNoteStackScaleProps };
//# sourceMappingURL=NoteStack.js.map
